'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'clsx';
import NextImage from 'next/image';
import PropTypes from 'prop-types';

import { addProtocol } from 'utils/url';

import styles from './BlockOverflowCarouselOverflowSlide.module.scss';

const typenameMap = {
    BlockOverflowCarouselOverflowSlide: 'isOverflow',
    BlockOverflowCarouselContainedSlide: 'isContained',
};

const originMap = {
    'Bottom Center': 'isBottomCenter',
    'Bottom Left': 'isBottomLeft',
    'Bottom Right': 'isBottomRight',
};

const BlockOverflowCarouselOverflowSlide = ({
    __typename,
    imageAnimationOrigin,
    image,
    isActive,
    isPrev,
    isInitialPaint,
    hasImagePriority,
}) => {
    const origin = imageAnimationOrigin ?? 'Bottom Center';

    return (
        <article
            className={cx(
                styles.root,
                styles[typenameMap[__typename]],
                styles[originMap[origin]],
                {
                    [styles.isActive]: isActive,
                    [styles.isPrev]: isPrev,
                    [styles.isInitialPaint]: isInitialPaint,
                }
            )}
        >
            <div className={styles.column}>
                <div className={styles.imageOverflow}>
                    <div className={styles.imageWrapper}>
                        {image?.url && (
                            <NextImage
                                className={styles.image}
                                src={addProtocol(image.url)}
                                alt={image.description || ''}
                                width={image?.width}
                                height={image?.height}
                                priority={hasImagePriority}
                                sizes="(max-width: 768px) 100vw, 50vw"
                            />
                        )}
                    </div>
                </div>
            </div>
        </article>
    );
};

BlockOverflowCarouselOverflowSlide.propTypes = {
    __typename: PropTypes.string,
    image: PropTypes.shape({
        description: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        url: PropTypes.string,
    }),
    imageAnimationOrigin: PropTypes.oneOf([
        'Bottom Center',
        'Bottom Left',
        'Bottom Right',
    ]),
    isActive: PropTypes.bool,
    isPrev: PropTypes.bool,
};

export default BlockOverflowCarouselOverflowSlide;
